import { history } from '../../store';

export const isInDossierRoute = () => {
  const { location } = history;
  return /^\/dossier\//.test(location.pathname);
}
